import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import '@styles/global.css'
import '@ui/styles/ui.css'
import { applyMode, applyTheme, setRemoteSync } from '@theme'
import { updateAppearance as apiUpdateAppearance } from '@api/appearance'

applyTheme()
applyMode()

setRemoteSync((payload) => {
  apiUpdateAppearance(payload).catch(() => { /* best-effort */ })
})

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV || 'development',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
